module.exports = __webpack_public_path__ + "img/shopping_application_1-2.478a7e97.jpg";